export default "__VITE_ASSET__55389994__"